import { useEffect } from 'react';
import store from "../../../../store";
import sqftShapeIntersectionsManager from "../../components/canvas/store/sqftShapeIntersectionsManager";

const useUpdateShapesIntersections = (visualizersLoaded) => {

  useEffect (() => {
    const state = store.getState()
    const {visualizerIsChanging} = state.serverState;
    if (visualizersLoaded.length && !visualizerIsChanging) {
      sqftShapeIntersectionsManager.updateShapesIntersections();
    }

  }, [visualizersLoaded]);
};

export default useUpdateShapesIntersections;

